import SuccessCard from "./SuccessCard";

export default SuccessCard;
